/** Optimized brand plates (640×640 source); originals remain in /brand/. */
export const brandAssets = {
  primaryLogo: {
    jpg640: '/brand/scrubledger-primary-logo-640.jpg',
    png640: '/brand/scrubledger-primary-logo-640.png',
    jpg320: '/brand/scrubledger-primary-logo-320.jpg',
    intrinsic: 640,
  },
  documentScan: {
    png640: '/brand/scrubledger-document-scan-640.png',
    intrinsic: 640,
  },
  surgicalTech: {
    jpg640: '/brand/scrubledger-surgical-tech-640.jpg',
    png640: '/brand/scrubledger-surgical-tech-640.png',
    intrinsic: 640,
  },
} as const;
